import { z } from 'zod';

/////////////////////////////////////////
// VIOLATION DISPLAY GROUP SCHEMA
/////////////////////////////////////////

export const ViolationDisplayGroupSchema = z.object({
  displaygroupId: z.number().int(),
  cityId: z.number().int(),
  groupName: z.string(),
  displayOrder: z.number().int(),
})

export type ViolationDisplayGroup = z.infer<typeof ViolationDisplayGroupSchema>

export default ViolationDisplayGroupSchema;
